<template>
<div class="chapter">
<div class="inner_page">
<p class="sgc-1">Other WildBlue Press Books By Steve Jackson </p>
<p class="sgc-1"><br/></p>
<p class="sgc-2">Smooth Talker</p>
<p class="sgc-3"><a href="http://wbp.bz/smoothtalker" target="_blank">http://wbp.bz/smoothtalker</a></p>
<p class="sgc-2">No Stone Unturned</p>
<p class="sgc-3"><a href="http://wbp.bz/nsua" target="_blank">http://wbp.bz/nsua</a></p>
<p class="sgc-2">Rough Trade</p>
<p class="sgc-3"><a href="http://wbp.bz/rta" target="_blank">http://wbp.bz/rta</a></p>
<p class="sgc-2">A Clockwork Murder</p>
<p class="sgc-3"><a href="http://wbp.bz/clockworkmurdera" target="_blank">http://wbp.bz/clockworkmurdera</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OtherBooks.vue?d36826d0